import { LayoutGrid, Baby, Droplets, Moon } from 'lucide-react'
import type { BottomNavItem } from '@/registry/types'

export const babyTrackerBottomNav: BottomNavItem[] = [
  { id: 'overview', label: 'Overview', icon: LayoutGrid, href: '/apps/baby-tracker?tab=overview' },
  { id: 'feeding', label: 'Feed', icon: Baby, href: '/apps/baby-tracker?tab=feeding' },
  { id: 'diaper', label: 'Diaper', icon: Droplets, href: '/apps/baby-tracker?tab=diaper' },
  { id: 'sleep', label: 'Sleep', icon: Moon, href: '/apps/baby-tracker?tab=sleep' },
]
